import React, { Component } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.state = {
      collapsed: true,
      user: null
    };
  }

  componentDidMount() {
    this.loadUser();
  }

  loadUser() {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        this.setState({ user });
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    }
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  handleLogout() {
    localStorage.removeItem('user');
    this.setState({ user: null });
    window.location.href = '/';
  }

  render() {
    const { user } = this.state;

    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
          <NavbarBrand tag={Link} to="/">Little Bear Coffee</NavbarBrand>
          <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
            <ul className="navbar-nav flex-grow">
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
              </NavItem>
              {user && (
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/order">Order Coffee</NavLink>
                </NavItem>
              )}
              {user && (user.role === 1 || user.role === 2) && (
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/service">Service Dashboard</NavLink>
                </NavItem>
              )}
              {user && user.role === 2 && (
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/admin">Admin</NavLink>
                </NavItem>
              )}
              {user && user.role === 0 && (
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/settings">Profile</NavLink>
                </NavItem>
              )}
              {user ? (
                <>
                  <NavItem>
                    <NavLink className="text-dark">
                      Welcome, {user.username}! {user.role === 1 && '(Service)'}{user.role === 2 && '(Admin)'}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <Button color="link" className="text-dark nav-link" onClick={this.handleLogout}>
                      Logout
                    </Button>
                  </NavItem>
                </>
              ) : (
                <>
                  <NavItem>
                    <NavLink tag={Link} className="text-dark" to="/login">Login</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="text-dark" to="/register">Register</NavLink>
                  </NavItem>
                </>
              )}
            </ul>
          </Collapse>
        </Navbar>
      </header>
    );
  }
}
